var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "sync-right-body",
      attrs: {
        id: "cloudSync",
        "element-loading-background": "rgba(0, 0, 0, 0.05)"
      }
    },
    [
      _c("div", { staticClass: "task-top" }, [
        _c("div", { staticClass: "task-top-position" }, [
          _c("div", { staticClass: "transfer-name" }, [
            _vm._v(_vm._s(_vm.$t("language.leftBanner.cloudSync")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "transfer-description" }, [
            _vm._v(_vm._s(_vm.$t("language.cloudSync.syncDescription")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-middle" }, [
        _c("div", { staticClass: "sync-choose" }, [
          _c(
            "div",
            {
              staticClass: "realTime-choose-button",
              class: !_vm.realTimeMode
                ? "realTime-select"
                : "realTime-no-select",
              style: { width: _vm.getWidth() },
              on: {
                click: function($event) {
                  _vm.onChangeRealTimeOption(
                    _vm.$t("language.cloudSync.normalSync")
                  )
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.cloudSync.normalSync")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "realTime-choose-button",
              class: _vm.realTimeMode
                ? "realTime-select"
                : "realTime-no-select",
              style: { width: _vm.getWidth() },
              on: {
                click: function($event) {
                  _vm.onChangeRealTimeOption(
                    _vm.$t("language.cloudSync.realTimeSync")
                  )
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.cloudSync.realTimeSync")))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "task-box-position" }, [
          _c(
            "div",
            {
              staticClass: "task-box",
              class: _vm.boxFrom,
              on: {
                click: function($event) {
                  return _vm.syncSourceDialogShow()
                }
              }
            },
            [
              _c("liteSelectView", { attrs: { data: _vm.liteSelectFromData } }),
              _vm._v(" "),
              _vm.hasSelect
                ? _c("div", { staticClass: "task-operating" }, [
                    _c(
                      "div",
                      {
                        class:
                          _vm.$i18n.locale == "france"
                            ? "task-operating-none"
                            : "task-operating-name"
                      },
                      [
                        _vm.$i18n.locale == "japanese"
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("language.cloudSync.from")))
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("language.cloudTransfer.from"))
                              )
                            ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-operating-des" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.cloudSync.syncOperateFrom"))
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasSelect
                ? _c("div", { staticClass: "task-main" }, [
                    _c("div", {
                      staticClass: "task-type task-icon",
                      class: _vm.singleDrives.driveType + "_big"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "task-catalog",
                        attrs: { title: _vm.singleDrives.cloudCatalog }
                      },
                      [_vm._v(_vm._s(_vm.singleDrives.cloudCatalog))]
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.twoWayShow
            ? _c("div", { staticClass: "task-box-middle" }, [
                _c("div", { staticClass: "arrow-position" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "realTime-font",
                    on: {
                      click: function($event) {
                        return _vm.switchModelType()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.cloudSync.swicthTwoWay")))]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.twoWayShow
            ? _c("div", { staticClass: "task-box-middle" }, [
                _c("div", { staticClass: "arrow-position arrow-top-position" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "arrow-position arrow-position-reverse"
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "realTime-font",
                    on: {
                      click: function($event) {
                        return _vm.switchModelType()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.cloudSync.switchOneWay")))]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "task-box",
              class: _vm.boxTo,
              on: {
                click: function($event) {
                  return _vm.syncAimDialogShow()
                }
              }
            },
            [
              _c("liteSelectView", { attrs: { data: _vm.liteSelectToData } }),
              _vm._v(" "),
              _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
                (_vm.hasSelectItems == false &&
                  _vm.hasSelectItemsMore == false) ||
                _vm.mulitDrives.length == 0
                  ? _c("div", { staticClass: "task-operating" }, [
                      _c("div", { staticClass: "task-operating-name" }, [
                        _vm.$i18n.locale == "japanese"
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("language.cloudSync.to")))
                            ])
                          : _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("language.cloudTransfer.to"))
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "task-operating-des" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.cloudSync.syncOperateTo"))
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasSelectItems || _vm.mulitDrives.length == 1
                  ? _c("div", { staticClass: "task-main" }, [
                      _c("div", {
                        staticClass: "task-type task-icon",
                        class: _vm.mulitDrives[0].driveType + "_big"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "task-catalog",
                          attrs: { title: _vm.mulitDrives[0].formUrl }
                        },
                        [_vm._v(_vm._s(_vm.mulitDrives[0].formUrl))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasSelectItemsMore && _vm.mulitDrives.length > 1
                  ? _c(
                      "div",
                      { staticClass: "task-source-more" },
                      _vm._l(_vm.mulitDrives, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "source-item",
                            on: {
                              mouseenter: function($event) {
                                _vm.hoverCurrent = index
                              },
                              mouseleave: function($event) {
                                _vm.hoverCurrent = -1
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "item-side" }, [
                              _c("div", {
                                staticClass: "item-formicon",
                                class: [
                                  item.dir ? "small-file" : "icon",
                                  item.dir
                                    ? "folder-small"
                                    : item.appName + "-small"
                                ]
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "item-url",
                                  attrs: { title: item.formUrl }
                                },
                                [_vm._v(_vm._s(item.formUrl))]
                              ),
                              _vm._v(" "),
                              _vm.hoverCurrent == index
                                ? _c("div", {
                                    staticClass:
                                      "icon-util round-cancel round-cancel-position",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.removeItem(index, item.id)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "definite-operating" }, [
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c(
                "div",
                {
                  staticClass: "operating-options",
                  on: {
                    click: function($event) {
                      return _vm.openSyncOptionsDialog()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon-util setting",
                    staticStyle: { float: "left" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "operating-position" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.options")))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.scheduleShow
                ? _c(
                    "div",
                    {
                      staticClass: "operating-schedule",
                      on: {
                        click: function($event) {
                          return _vm.openSchduleDialog()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon-util",
                        class: _vm.checkedSchedule ? "check" : "nocheck",
                        staticStyle: { float: "left" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.checkedOpen()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "operating-position" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.schedule")))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("edit-input", {
                ref: "editInput",
                attrs: {
                  inputValue: _vm.inputValue,
                  submitTaskName: _vm.submiSynctName
                }
              }),
              _vm._v(" "),
              !_vm.checkedSchedule
                ? _c(
                    "button",
                    {
                      staticClass: "transfer-button",
                      on: {
                        click: function($event) {
                          return _vm.syncNow()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "icon sync-icon-position cloudsync"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: { float: "left", "line-height": "40px" }
                        },
                        [_vm._v(_vm._s(_vm.$t("language.cloudSync.syncNow")))]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkedSchedule
                ? _c(
                    "div",
                    {
                      staticClass: "schedule-button",
                      on: {
                        click: function($event) {
                          return _vm.syncAddTask($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "text-button-position" }, [
                        _c("div", {
                          staticClass: "icon transfer-task-position  cloudsync"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { float: "left", color: "#fff" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.cloudTransfer.addTaskOnly")
                              )
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "more-button-position",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              _vm.addTaskOpen($event),
                                ($event.cancelBubble = true)
                            }
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "icon-util  transfer-up-position",
                            class: _vm.addTaskShow
                              ? "transfer-up"
                              : "transfer-down",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.addTaskOpen($event)
                              }
                            }
                          })
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.addTaskShow
                ? _c(
                    "div",
                    {
                      staticClass: "addTask",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.addTaskSyncNow()
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass:
                          "task-type-icon-min sync-blue-min sync-blue-position"
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { float: "left" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("language.cloudTransfer.addSyncTaskNow")
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("transition", { attrs: { name: "flowSync" } }, [
                _vm.flowShow
                  ? _c(
                      "div",
                      {
                        staticClass: "flow-sync-icon",
                        attrs: { id: "syncFlow" }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "icon transfer-task-position cloudsync flow-sync-position"
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-buttom" }),
      _vm._v(" "),
      _c("syncSourceDialog", { ref: "syncSourceDialog" }),
      _vm._v(" "),
      _c("syncAimsDialog", { ref: "syncAimsDialog" }),
      _vm._v(" "),
      _c("syncOptionsDialog", { ref: "syncOptionsDialog" }),
      _vm._v(" "),
      _c("transferScheduleDialog", { ref: "transferScheduleDialog" }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" }),
      _vm._v(" "),
      _c("remindBindEmailDialog", { ref: "remindBindEmailDialog" }),
      _vm._v(" "),
      _c("realTimeNoticeDialog", { ref: "realTimeNoticeDialog" }),
      _vm._v(" "),
      _c("idlingDialog", { ref: "idlingDialog" }),
      _vm._v(" "),
      _c("liteSelect", {
        ref: "syncFromTree",
        attrs: {
          showCheckbox: false,
          showFileNode: false,
          showNewFolder: false
        },
        on: { selectDone: _vm.selectDoneFrom }
      }),
      _vm._v(" "),
      _c("liteSelect", {
        ref: "syncToTree",
        attrs: {
          showCheckbox: false,
          showFileNode: false,
          showNewFolder: true
        },
        on: { selectDone: _vm.selectDoneTo }
      }),
      _vm._v(" "),
      _c("liteOptions", {
        ref: "syncOptions",
        attrs: { data: _vm.liteOptionsData },
        on: { ok: _vm.okOptions }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dca64af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dca64af","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/cloud_sync.vue
// module id = null
// module chunks = 